// Development
// export default {
//   apiHost: process.env.REACT_APP_API_HOST || 'http://localhost:5000',
//   AWS: {
//    S3bucket: "https://s3-us-west-2.amazonaws.com/hatleycobb-storage/",
//   }
// };

//Staging
// export default {
//   apiHost: process.env.REACT_APP_API_HOST || 'http://hatleycobb-2110680363.us-west-2.elb.amazonaws.com',
//   AWS: {   
//    S3bucket: "https://s3-us-west-2.amazonaws.com/hatleycobb-storage/",   
//   },
// };
			
// Production
export default {
  apiHost: process.env.REACT_APP_API_HOST || 'https://api.acretrac.com',
  AWS: {   
   S3bucket: "https://s3.us-east-1.amazonaws.com/acretrac-live-storage/",   
  },
};


// WEBPACK FOOTER //
// ./src/config.js